import type { DpModule } from '@/core/modules/DpModule';
import type { IDpProvider } from '@/core/di/DpProvider';
import { RootModule } from '@/common/root';
import { AdaptersProvider } from './providers/AdaptersProvider';
import { RouterProvider } from './providers/RouterProvider';

export class AppConfigModule implements DpModule {
  static readonly namespace = Symbol('AppConfigModule');

  static readonly requires = [RootModule];

  providers(): IDpProvider[] {
    return [RouterProvider, AdaptersProvider];
  }
}
